import { render, staticRenderFns } from "./JournalSummary.vue?vue&type=template&id=69f22d68&scoped=true"
import script from "./JournalSummary.vue?vue&type=script&lang=js"
export * from "./JournalSummary.vue?vue&type=script&lang=js"
import style0 from "./JournalSummary.vue?vue&type=style&index=0&id=69f22d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f22d68",
  null
  
)

export default component.exports